/**
 * The SoundManager is a scene that is intended to be launched after preload
 * It is intended to be kept running conquerently against all other scenes
 */

import DataManager from './DataManager';
import {Howl, Howler} from './Howler.js';

let dataManager;

class SoundManager extends Phaser.Scene {
  init () {
    dataManager = new DataManager();
  }
  
  static cache = {};

  create () {
    let g = this;
    //let entries = this.cache.audio.entries.entries;
    let loops = {};
    let sfx = [];
    let sfxCache = [];
    let sfxArrays = {};
    let loopState = {
      activeLoop: null,
      activeLoopVolume: 0,
      fadeOutLoop: null,
      fadeOutLoopVolume: 0,
      isPaused: false
    };

    _.each(SoundManager.cache, (obj, key) => {
      if (key.indexOf('loop-') === 0) {
        //loops[key] = g.sound.add(key, { loop: true });
        //loops[key].setVolume(0);
        
        loops[key] = new Howl({
          src: obj.src
        });
        loops[key].volume(0);
      } else if (key.indexOf('array-') === 0) {
        let arrName = key.replace('array-', '');
        let index = arrName.lastIndexOf('-');
        arrName = arrName.slice(0, index);
        if (!sfxArrays[arrName]) {
          sfxArrays[arrName] = [];
        }
        // sfxArrays[arrName].push(g.sound.add(key));
        sfxArrays[arrName].push(key);
      } else {
        sfx.push(key);
      }
    });
    g.assets = { loops, sfxArrays, sfx, sfxCache, loopState };
    
    this.onWindowBlur = this.OnWindowBlur.bind(this);
    this.onWindowFocus = this.OnWindowFocus.bind(this);
    this.onVisibilityChange = this.OnVisibilityChange.bind(this);
    
    window.addEventListener("blur", this.onWindowBlur);
    window.addEventListener("focus", this.onWindowFocus);
    document.addEventListener("visibilitychange", this.onVisibilityChange);
    // console.log('SoundManager.create');
  }

  update () {
    let g = this;
    let { loops, loopState, sfxCache } = g.assets;

    for (let i = sfxCache.length - 1; i > -1; i--) {
      let s = sfxCache[i];
      var isPlaying = this.isPlaying(s);
      
      if (!isPlaying) {
        s.stop();
        sfxCache.splice(i, 1);
      }
    }

    // if (sfxCache.length) {
    //   console.log('sfxCache.length', sfxCache.length);
    // }

    if (dataManager.getItem('musicOn') === true && loopState.isPaused === false) {
      // active loop logic when music is on
      if (loopState.activeLoop) {
        // let activeLoop = loopState.activeLoop;
        if (loopState.activeLoopVolume !== 1) {
          let volume = Math.round(loopState.activeLoopVolume * 100);
          volume = volume + 1 < 100 ? volume + 1 : 100;
          loopState.activeLoopVolume = volume / 100;
        }
      }
    } else {
      if (loopState.activeLoop) {
        // active loop logic when music is off
        if (loopState.activeLoopVolume !== 0) {
          let volume = Math.round(loopState.activeLoopVolume * 100);
          volume = volume - 2 > 0 ? volume - 2 : 0;
          loopState.activeLoopVolume = volume / 100;
        }
      }
    }
    // fade loop logic
    if (loopState.fadeOutLoop) {
      if (loopState.fadeOutLoopVolume !== 0) {
        let volume = Math.round(loopState.fadeOutLoopVolume * 100);
        volume = volume - 2 > 0 ? volume - 2 : 0;
        loopState.fadeOutLoopVolume = volume / 100;
      }
    }

    // only set our volumes at the very end of the loop
    if (loopState.activeLoop) {
      let activeLoop = loopState.activeLoop;
      if (activeLoop.volume !== loopState.activeLoopVolume) {
        activeLoop.volume(loopState.activeLoopVolume);
        // console.log('update activeLoop.volume', activeLoop.volume, loopState.activeLoopVolume);
      }
    }
    if (loopState.fadeOutLoop) {
      let fadeOutLoop = loopState.fadeOutLoop;
      if (fadeOutLoop.volume === 0) {
        fadeOutLoop.stop();
        loopState.fadeOutLoop = null;
      } else if (fadeOutLoop.volume !== loopState.fadeOutLoopVolume) {
        fadeOutLoop.volume(loopState.fadeOutLoopVolume);
        // console.log('fadeOutLoop.volume', fadeOutLoop.volume);
      }
    }
  }

  toggleMusic () {
    let g = this;
    let { loops, loopState } = g.assets;
    if (dataManager.getItem('musicOn') === true) {
      dataManager.setItem('musicOn', false);
    } else {
      dataManager.setItem('musicOn', true);
    }
  }
  toggleSounds () {
    if (dataManager.getItem('soundsOn') === true) {
      dataManager.setItem('soundsOn', false);
      // TODO turn sound effects off
    } else {
      dataManager.setItem('soundsOn', true);
      // TODO turn sound effects on
    }
  }
  isSoundsOn () {
    return dataManager.getItem('soundsOn');
  }
  isMusicOn () {
    return dataManager.getItem('musicOn');
  }
  playSound (key) {
    let g = this;
    let { sfxArrays, sfx, sfxCache } = g.assets;
    if (this.isSoundsOn() === true) {
      // console.log('play sound ' + key);
      if (sfx.indexOf(key) > -1) {
        let s = new Howl({
          src: SoundManager.cache[key].src
        });
        s.play();
        sfxCache.push(s);
      } else if (sfxArrays[key]) {
        let arr = sfxArrays[key];
        let rndKey = arr[_.random(arr.length - 1)];
        let s = new Howl({
          src: SoundManager.cache[rndKey].src
        })
        s.play();
        sfxCache.push(s);
      } else {
        console.warn(`sound does not exist${key}`);
      }
    }
  }
  playMusic (key) {
    let g = this;
    let { loops, loopState } = g.assets;
    if (!loops[key]) {
      console.warn(`loop does not exist${key}`);
      return;
    }
    if (loops[key] === loopState.activeLoop) {
      return;
    }
    // console.log('play music ' + key, loopState);
    if (loopState.activeLoop !== null) {
      if (loopState.fadeOutLoop !== null) {
        loopState.fadeOutLoop.volume(0);
        loopState.fadeOutLoop.stop();
      }
      // console.log('Set Fadeout Loop');
      loopState.fadeOutLoop = loopState.activeLoop;
      loopState.fadeOutLoopVolume = loopState.fadeOutLoop.volume;
    }
    loopState.activeLoop = loops[key];
    if (this.isMusicOn()) {
      loopState.activeLoopVolume = loopState.activeLoop.volume;
      loopState.activeLoop.play();
      loopState.activeLoop.loop(true);
    } else {
      loopState.activeLoop.volume(0);
      loopState.activeLoopVolume = 0;
      // console.log('Set Volume to ZERO', loopState.activeLoop);
    }
  }
  pauseMusic () {
    let g = this;
    let { loopState, sfxCache, sfxArrays } = g.assets;
    loopState.isPaused = true;
    _.each(sfxCache, (s) => {
      s.stop();
    });
  }
  resumeMusic () {
    let g = this;
    let { loopState } = g.assets;
    loopState.isPaused = false;
    if (loopState.activeLoop && !this.isPlaying(loopState.activeLoop)) {
      loopState.activeLoop.play();
      // console.log('resume active loop');
    }
  }
  
  isPlaying(sound){
    for(var i = 0; i<sound._sounds.length; i++){
        if(!sound._sounds[i]._ended){
            return true;
        }
    }
    
    return false;
      
  }
  
  OnWindowBlur = function() {
    Howler.mute(true);
  };

  OnWindowFocus = function() {
    Howler.mute(false);
  };

  OnVisibilityChange = function() {
      if(document.visibilityState == 'hidden'){
          this.OnWindowBlur();
      }
      else{
          this.OnWindowFocus();
      }

  };
};

export default SoundManager;
